(() => {
  const KEY = 'vital_wishlist_v1';
  let volatileItems = null;
  const translations = {
    en: ['Save product', 'Remove from saved products', 'Remove'],
    nl: ['Product bewaren', 'Verwijderen uit opgeslagen producten', 'Verwijderen'],
    fr: ['Enregistrer le produit', 'Retirer des favoris', 'Retirer'],
    de: ['Produkt speichern', 'Aus gespeicherten Produkten entfernen', 'Entfernen'],
    es: ['Guardar producto', 'Quitar de guardados', 'Quitar'],
    it: ['Salva prodotto', 'Rimuovi dai salvati', 'Rimuovi'],
    pt: ['Guardar produto', 'Remover dos guardados', 'Remover'],
    sv: ['Spara produkt', 'Ta bort från sparade produkter', 'Ta bort'],
    no: ['Lagre produkt', 'Fjern fra lagrede produkter', 'Fjern'],
    da: ['Gem produkt', 'Fjern fra gemte produkter', 'Fjern'],
    pl: ['Zapisz produkt', 'Usuń z zapisanych produktów', 'Usuń']
  };
  const messages = translations[(document.documentElement.lang || 'en').toLowerCase().split('-')[0]] || translations.en;

  const read = () => {
    if (volatileItems !== null) return volatileItems;
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return volatileItems || [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      volatileItems = null;
    } catch (_) {
      volatileItems = items;
    }
  };

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));

  const getButtonData = (button) => ({
    id: String(button.dataset.productId || ''),
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '',
    image: button.dataset.productImage || '',
    price: button.dataset.productPrice || ''
  });

  // Saved items can persist across country/language switches. Open them
  // under the current Shopify locale instead of an older locale's URL.
  const localizeSavedProductUrl = (savedUrl) => {
    try {
      const url = new URL(savedUrl, window.location.origin);
      if (url.origin !== window.location.origin) return savedUrl;
      const marker = '/products/';
      const index = url.pathname.indexOf(marker);
      if (index < 0) return savedUrl;
      const productTail = url.pathname.slice(index + marker.length);
      if (!productTail) return savedUrl;
      const rawRoot = window.Shopify?.routes?.root || '/';
      const root = rawRoot.endsWith('/') ? rawRoot : rawRoot + '/';
      return root + 'products/' + productTail + url.search + url.hash;
    } catch (_) {
      return savedUrl;
    }
  };

  const updateUI = () => {
    const items = read();
    const ids = new Set(items.map((item) => String(item.id)));

    document.querySelectorAll('[data-vf-wishlist-toggle]').forEach((button) => {
      const active = ids.has(String(button.dataset.productId || ''));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const title = button.dataset.productTitle || '';
      button.setAttribute('aria-label', `${active ? messages[1] : messages[0]} ${title}`.trim());
    });

    document.querySelectorAll('[data-vf-wishlist-count]').forEach((count) => {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });

    const empty = document.querySelector('[data-vf-wishlist-empty]');
    const list = document.querySelector('[data-vf-wishlist-items]');
    const clear = document.querySelector('[data-vf-wishlist-clear]');

    if (empty) empty.hidden = items.length > 0;
    if (clear) clear.hidden = items.length === 0;

    if (list) {
      list.innerHTML = items.map((item) => {
        const localizedUrl = escapeHtml(localizeSavedProductUrl(item.url || ''));
        return `
        <article class="vf-wishlist-item">
          <a class="vf-wishlist-item__image" href="${localizedUrl}">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}
          </a>
          <div class="vf-wishlist-item__info">
            <a class="vf-wishlist-item__title" href="${localizedUrl}">${escapeHtml(item.title)}</a>
            <strong>${escapeHtml(item.price)}</strong>
            <button type="button" data-vf-wishlist-remove="${escapeHtml(item.id)}">${escapeHtml(messages[2])}</button>
          </div>
        </article>
      `;
      }).join('');
    }
  };

  let previouslyFocused = null;

  const openDrawer = () => {
    const shell = document.querySelector('[data-vf-wishlist-shell]');
    if (!shell) return;
    previouslyFocused = document.activeElement;
    shell.hidden = false;
    requestAnimationFrame(() => shell.classList.add('is-open'));
    document.documentElement.classList.add('vf-wishlist-open');
    updateUI();
    shell.querySelector('[data-vf-wishlist-close].vf-wishlist-drawer__close')?.focus({ preventScroll: true });
  };

  const closeDrawer = () => {
    const shell = document.querySelector('[data-vf-wishlist-shell]');
    if (!shell || shell.hidden) return;
    shell.classList.remove('is-open');
    document.documentElement.classList.remove('vf-wishlist-open');
    if (previouslyFocused && typeof previouslyFocused.focus === 'function' && previouslyFocused.isConnected) {
      previouslyFocused.focus({ preventScroll: true });
    }
    previouslyFocused = null;
    window.setTimeout(() => {
      if (!shell.classList.contains('is-open')) shell.hidden = true;
    }, 220);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-vf-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const product = getButtonData(toggle);
      if (!product.id) return;

      const items = read();
      const index = items.findIndex((item) => String(item.id) === product.id);
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift(product);
      }
      write(items);
      updateUI();
      return;
    }

    if (event.target.closest('[data-vf-wishlist-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-vf-wishlist-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const remove = event.target.closest('[data-vf-wishlist-remove]');
    if (remove) {
      const id = String(remove.dataset.vfWishlistRemove || '');
      write(read().filter((item) => String(item.id) !== id));
      updateUI();
      return;
    }

    if (event.target.closest('[data-vf-wishlist-clear]')) {
      write([]);
      updateUI();
    }
  });

  document.addEventListener('keydown', (event) => {
    const shell = document.querySelector('[data-vf-wishlist-shell]');
    if (!shell || shell.hidden || !shell.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    const drawer = shell.querySelector('[role="dialog"]');
    const focusable = Array.from(drawer?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])') || [])
      .filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('DOMContentLoaded', updateUI);
  document.addEventListener('shopify:section:load', updateUI);
  window.addEventListener('storage', updateUI);
})();